module.exports = __webpack_public_path__ + "media/images/pages/about_us/partners/logo_french_tech-aa854f2947fa360f9f2e685ee37f4584.png";